import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import {
  Card,
  CardHeader,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
  Badge,
  ModalBody,
  Table,
  ModalHeader,
} from 'reactstrap';
import Header from 'components/Headers/Header.js';
import {
  FaEdit,
  FaPlusCircle,
  FaTimesCircle,
  FaCheckCircle,
  FaTable,
  FaEyeSlash,
  FaEye,
  FaList,
  FaSearch,
  FaHistory,
  FaRegListAlt,
  FaMoneyBill,
} from 'react-icons/fa';
import api from 'services/api';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { iTabelaGenerica } from 'models/TabelaGenerica';
import { Link } from 'react-router-dom';
import { Column, AutoSizer, List } from 'react-virtualized';
import './style.css';
import ModalLog from 'components/ModalLog';
import formatCurrency from 'utils/formatCurrency';
import { BuscarRegras } from './styles';

interface editTabelaGenerica extends iTabelaGenerica {
  labelValido: boolean;
}

export interface iMaterial {
  id: number;
  diteCodigo: string;
  fabrCodigo?: string;
  fabrEmprCodigo?: string;
  diteDgpeCodigo?: string;
  descricao?: string;
  dataUltimaIntegracao?: any;
  createdAt?: any;
  updatedAt?: any;
  isAtivo: boolean;
  codigoSap: string | null;
  integracaoId: number | null;
}

interface iMaterialPrecificacao {
  id: number;
  materialId: number;
  atividade: string;
  empresa: string;
  valor: number;
  updatedAt?: any;
  integracaoId: number | null;
  custo: number | null;
  custoImp: number | null;
  canalDistribuicao: string | null;
  centroLucro: string | null;
  organizacaoVenda: string | null;
  setorAtividade: string | null;
}

interface iMaterialComposicao {
  id: number;
  material: iMaterial;
  materialId: number;
  quantidade: string;
  updatedAt?: any;
  integracaoId: number | null;
}

const Materiais: React.FC = () => {
  const [listaMaterial, setListaMaterial] = useState([] as iMaterial[]);
  const [listaMaterialFiltrada, setListaMaterialFiltrada] = useState(
    [] as iMaterial[],
  );
  const [listaPrecificacao, setListaPrecificacao] = useState(
    [] as iMaterialPrecificacao[],
  );
  const [listaComposicao, setListaComposicao] = useState(
    [] as iMaterialComposicao[],
  );
  const [modalPrecificacaoVisivel, setModalPrecificacaoVisivel] =
    useState(false);
  const [modalComposicaoVisivel, setModalComposicaoVisivel] = useState(false);
  const [loadingDadosPrecificacao, setLoadingDadosPrecificacao] =
    useState(false);
  const [loadingDadosComposicao, setLoadingDadosComposicao] = useState(false);
  const [modalMaterial, setModalMaterial] = useState<iMaterial>(
    {} as iMaterial,
  );

  const [modalLogVisivel, setModalLogVisivel] = useState(false);
  const [mostrarDesativados, setMostrarDesativados] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalProp, setModalProp] = useState('');
  const [campoBusca, setCampoBusca] = useState('');

  async function carregarDados() {
    setLoading(true);
    const response = await api.get('/material');

    const lista = response.data as iMaterial[];

    setListaMaterial(lista);
    setLoading(false);
  }

  useEffect(() => {
    carregarDados();
  }, []);

  async function filtrar() {
    let lista = listaMaterial;

    if (campoBusca) {
      lista = listaMaterial.filter(item => {
        return (
          String(item.codigoSap)
            .toUpperCase()
            .includes(campoBusca.toUpperCase()) ||
          String(item.descricao)
            .toUpperCase()
            .includes(campoBusca.toUpperCase()) ||
          String(item.diteCodigo)
            .toUpperCase()
            .includes(campoBusca.toUpperCase())
        );
      });
    }

    const novaLista = lista.filter(item =>
      mostrarDesativados ? true : item.isAtivo === true,
    );

    setListaMaterialFiltrada(novaLista);
  }

  useEffect(() => {
    if (listaMaterialFiltrada) {
      filtrar();
    }
  }, [listaMaterial, mostrarDesativados, campoBusca]);

  async function mostrarModalLog(material: iMaterial) {
    setModalProp(`${material.id}`);
    setModalLogVisivel(true);
  }

  async function mostrarLogPrecificacao(material: iMaterial) {
    setLoadingDadosPrecificacao(true);
    setListaPrecificacao([]);
    setModalMaterial({} as iMaterial);

    const response = await api.get(`/material/${material.id}/precificacao`);

    const lista = response.data as iMaterialPrecificacao[];

    setModalMaterial(material);
    setListaPrecificacao(lista);
    setModalPrecificacaoVisivel(true);
    setLoadingDadosPrecificacao(false);
  }

  async function mostrarLogComposicao(material: iMaterial) {
    setLoadingDadosComposicao(true);
    setListaComposicao([]);
    setModalMaterial({} as iMaterial);

    const response = await api.get(`/material/${material.id}/composicao`);

    const lista = response.data as iMaterialComposicao[];

    setModalMaterial(material);
    setListaComposicao(lista);
    setModalComposicaoVisivel(true);
    setLoadingDadosComposicao(false);
  }

  const rowRenderer = ({
    index,
    isScrolling,
    key,
    style,
  }: {
    index: any;
    isScrolling: any;
    key: any;
    style: any;
  }) => {
    const objeto = listaMaterialFiltrada[index];

    return (
      <div
        className="list-detail"
        key={key}
        style={{
          ...style,
        }}
      >
        <Row>
          <Col sm="1">
            <strong>{objeto.id}</strong>
          </Col>
          <Col sm="1">
            <strong>{objeto.codigoSap ?? ''}</strong>
          </Col>
          <Col sm="1">
            <strong>{objeto.diteCodigo}</strong>
          </Col>
          <Col sm="6">{objeto.descricao}</Col>
          <Col sm="2">
            <div className="float-right">
              <Tooltip title="Visualizar Logs">
                <Button
                  size="sm"
                  color="default"
                  outline
                  onClick={() => mostrarModalLog(objeto)}
                >
                  <FaHistory />
                </Button>
              </Tooltip>

              <Button
                size="sm"
                className="btn-icon"
                color="info"
                type="button"
                title="Visualizar dados de Precificação"
                onClick={() => {
                  mostrarLogPrecificacao(objeto);
                }}
              >
                <FaMoneyBill />
              </Button>

              <Button
                size="sm"
                className="btn-icon"
                color="info"
                type="button"
                title="Visualizar dados de Composição"
                onClick={() => {
                  mostrarLogComposicao(objeto);
                }}
              >
                <FaRegListAlt />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  async function filtroTabela(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const search = event.target.value;

    setCampoBusca(search);
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}

      <ModalLog
        nomeChave="material_id"
        valorChave={modalProp}
        titulo="Logs"
        modalState={modalLogVisivel}
        toggle={() => setModalLogVisivel(false)}
      />

      <Modal
        className="modal-dialog-centered"
        size="xl"
        style={{ maxWidth: '80vw', width: '100%' }}
        isOpen={modalPrecificacaoVisivel}
        toggle={() => setModalPrecificacaoVisivel(false)}
      >
        <ModalBody>
          <h3 className="mb-0">
            Detalhes de Precificação do material {modalMaterial.diteCodigo}
          </h3>
          {loadingDadosPrecificacao && (
            <>Buscando dados da precificação do material</>
          )}
          {!loadingDadosPrecificacao && (
            <>
              <Table
                className="align-items-center table-flush table-striped mt-1"
                responsive
              >
                <thead>
                  <tr>
                    <th>Canal Distrib.</th>
                    <th>Centro Lucro</th>
                    <th>Org. Venda</th>
                    <th>Setor Ativ.</th>
                    <th>Valor</th>
                    <th>Custo</th>
                    <th>Custo Imp</th>
                    <th>Integração</th>
                  </tr>
                </thead>
                <tbody>
                  {listaPrecificacao.map(
                    (registro: iMaterialPrecificacao, index: number) => {
                      return (
                        <tr key={`id_${index}`}>
                          <td>{registro.canalDistribuicao} </td>
                          <td>{registro.centroLucro} </td>
                          <td>{registro.organizacaoVenda} </td>
                          <td>{registro.setorAtividade} </td>
                          <td>{formatCurrency(registro.valor ?? 0)} </td>
                          <td>{formatCurrency(registro.custo ?? 0)} </td>
                          <td>{formatCurrency(registro.custoImp ?? 0)} </td>
                          <td
                            style={{
                              whiteSpace: 'pre',
                              wordWrap: 'break-word',
                            }}
                          >
                            <div
                              style={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'keep-all',
                              }}
                            >
                              #{registro.integracaoId ?? null}
                              {' em '}
                              {new Intl.DateTimeFormat('pt-BR', {
                                dateStyle: 'short',
                                timeStyle: 'medium',
                              }).format(new Date(registro.updatedAt))}
                            </div>
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      <Modal
        className="modal-dialog-centered"
        size="xl"
        isOpen={modalComposicaoVisivel}
        style={{ maxWidth: '80vw', width: '100%' }}
        toggle={() => setModalComposicaoVisivel(false)}
      >
        <ModalBody>
          <h3 className="mb-0">
            Detalhes da Composição do material {modalMaterial.diteCodigo}
          </h3>
          {loadingDadosComposicao && (
            <>Buscando dados da composição do material</>
          )}
          {!loadingDadosComposicao && (
            <>
              <Table
                className="align-items-center table-flush table-striped mt-1"
                responsive
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>SAP</th>
                    <th>DomSGE</th>
                    <th>Empresa</th>
                    <th>Descrição</th>
                    <th>Quantidade</th>
                    <th>Integração</th>
                  </tr>
                </thead>
                <tbody>
                  {listaComposicao.map(
                    (registro: iMaterialComposicao, index: number) => {
                      return (
                        <tr key={`id_${index}`}>
                          <td>{registro.material.id} </td>
                          <td>{registro.material.codigoSap ?? ''} </td>
                          <td>{registro.material.diteCodigo} </td>
                          <td>{registro.material.fabrEmprCodigo ?? ''} </td>
                          <td
                            style={{
                              whiteSpace: 'pre',
                              wordWrap: 'break-word',
                            }}
                          >
                            <div
                              style={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'keep-all',
                              }}
                            >
                              {registro.material.descricao}
                            </div>
                          </td>
                          <td>{registro.quantidade} </td>
                          <td
                            style={{
                              whiteSpace: 'pre',
                              wordWrap: 'break-word',
                            }}
                          >
                            <div
                              style={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'keep-all',
                              }}
                            >
                              #{registro.integracaoId ?? null}
                              {' em '}
                              {new Intl.DateTimeFormat('pt-BR', {
                                dateStyle: 'short',
                                timeStyle: 'medium',
                              }).format(new Date(registro.updatedAt))}
                            </div>
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col sm="6">
                    <h3 className="mb-0">Lista de Materiais</h3>
                  </Col>
                  <Col sm="6" hidden>
                    <FormControlLabel
                      className="float-right"
                      control={
                        <Checkbox
                          checked={mostrarDesativados}
                          onChange={event =>
                            setMostrarDesativados(event.target.checked)
                          }
                          color="primary"
                        />
                      }
                      label="Mostrar desativados"
                    />
                  </Col>
                </Row>
              </CardHeader>

              <Row>
                <Col sm="8">
                  <div className="ml-4">
                    <i>
                      Exibindo {listaMaterialFiltrada?.length ?? 0} de{' '}
                      {listaMaterial
                        ? listaMaterial.filter(item =>
                            mostrarDesativados ? true : item.isAtivo === true,
                          )?.length ?? 0
                        : 0}{' '}
                      registros
                    </i>
                  </div>
                </Col>
                <Col sm="4">
                  <BuscarRegras
                    className="float-right mr-2"
                    id="outlined-basic"
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    type="text"
                    onChange={event => {
                      filtroTabela(event);
                    }}
                  />
                </Col>
              </Row>

              <div
                id="list-container"
                className="list-container"
                style={{
                  width: '100%',
                  height: '80vh',
                  overflow: 'hidden',
                }}
              >
                <AutoSizer disableWidth>
                  {({ height }) => {
                    return (
                      <>
                        <Row className="header-list-detail">
                          <Col sm="1">
                            <strong>#</strong>
                          </Col>
                          <Col sm="1">
                            <strong>SAP</strong>
                          </Col>
                          <Col sm="1">
                            <strong>DomSGE</strong>
                          </Col>
                          <Col sm="6">
                            <strong>Descrição</strong>
                          </Col>
                          <Col sm="2" />
                        </Row>
                        <List
                          width={1}
                          height={height - 50}
                          overscanRowsCount={2}
                          rowCount={listaMaterialFiltrada.length}
                          rowHeight={50}
                          rowRenderer={rowRenderer}
                          containerStyle={{ width: '100%', maxWidth: '100%' }}
                          style={{ width: '100%' }}
                        />
                      </>
                    );
                  }}
                </AutoSizer>
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Materiais;
